import { InsightsEvents } from "@algolia/client-insights";
import { algolia as algoliaClient } from ".";

const EVENT_BATCH_SIZE = 10;
const FLUSH_INTERVAL = 2000;
const MAX_RETRY_ATTEMPTS = 5;

const queue: InsightsEvents["events"] = [];
let isFlushing = false;
let retryCount = 0;

function getRetryDelay(attempt: number) {
  return Math.min(1000 * Math.pow(2, attempt), 10000);
}

async function flushQueue() {
  if (isFlushing || queue.length === 0) return;
  isFlushing = true;

  try {
    while (queue.length > 0) {
      const eventsToSend = queue.splice(0, EVENT_BATCH_SIZE);
      const response = await algoliaClient.analytics.pushEvents({
        events: eventsToSend,
      });

      if (response.status !== 200) {
        queue.unshift(...eventsToSend);
        throw new Error(`Failed to send events, status: ${response.status}`);
      }
      retryCount = 0;
    }
  } catch (error) {
    retryCount++;
    if (retryCount <= MAX_RETRY_ATTEMPTS) {
      const delay = getRetryDelay(retryCount);
      setTimeout(() => {
        isFlushing = false;
        void flushQueue();
      }, delay);
      console.error(
        `Analytics retry #${retryCount}, will try again in ${delay}ms`,
        error
      );
      return;
    } else {
      console.error("Analytics queue failed permanently after retries:", error);
      retryCount = 0;
    }
  }
  isFlushing = false;
}

setInterval(flushQueue, FLUSH_INTERVAL);

export function queueAnalyticsEvent(event: InsightsEvents["events"][number]) {
  queue.push(event);
  if (queue.length >= EVENT_BATCH_SIZE) void flushQueue();
}
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    void flushQueue();
  });
}
